import type { TransportZustand } from './geldtuete.ts'

/** Badge tone of each bag state (shared/ui Badge): the same colours in the Schulportal, the courier page and the Büro. */
export const ZUSTAND_TON: Record<TransportZustand, 'success' | 'warn' | 'neutral' | 'info' | 'violet' | 'teal'> = {
  offen: 'success', voll: 'warn', zu: 'neutral', uebergeben: 'info', unterwegs: 'violet', zentrale: 'teal', kontrolliert: 'success',
}

/** Material Symbols icon of each bag state (prototype v44 TT_ST). */
export const ZUSTAND_SYMBOL: Record<TransportZustand, string> = {
  offen: 'lock_open', voll: 'block', zu: 'lock', uebergeben: 'hourglass_top', unterwegs: 'local_shipping', zentrale: 'move_to_inbox', kontrolliert: 'verified',
}
